import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {
  createChileanBankAccount,
  deleteChileanBankAccount,
  getChileanBankAccounts,
} from "../../services/wallet/chileanBankAccount.service";

const QUERY_KEY = ["chileanBankAccounts"];

// Fetch all Chilean bank accounts for the authenticated user.
export const useGetChileanBankAccounts = () => {
  const {data, isLoading, isError, refetch} = useQuery({
    queryKey: QUERY_KEY,
    queryFn: getChileanBankAccounts,
    staleTime: 2 * 60 * 1000, // 2 min
  });

  return {
    accounts: data?.data?.data ?? [],
    isLoading,
    isError,
    refetch,
  };
};

// Create a new Chilean bank account and refresh the list on success.
export const useCreateChileanBankAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createChileanBankAccount,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: QUERY_KEY});
    },
  });
};

// Soft-delete an account and refresh the list on success.
export const useDeleteChileanBankAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteChileanBankAccount,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: QUERY_KEY});
    },
  });
};
